"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsby = require("gatsby");

var _I18nContext = require("./I18nContext");

var Link = function Link(_ref) {
  var to = _ref.to,
      lng = _ref.lng,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["to", "lng", "children"]);
  return _react["default"].createElement(_gatsby.Link, (0, _extends2["default"])({
    to: lng ? "/".concat(lng).concat(to) : "".concat(to)
  }, rest), children);
};

Link.propTypes = {
  to: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].node.isRequired
};

var _default = function _default(props) {
  return _react["default"].createElement(_I18nContext.I18nConsumer, null, function (value) {
    console.log('!!! value', value);
    return _react["default"].createElement(Link, (0, _extends2["default"])({
      lng: 'pl'
    }, props));
  });
};

exports["default"] = _default;